import React from 'react';
import './ImportStepper.css';

export default function ImportStepper({ steps, currentStep }) {
  return (
    <div className="import-stepper">
      <div className="stepper-container">
        {steps.map((step, index) => {
          const isCompleted = step.number < currentStep;
          const isCurrent = step.number === currentStep;
          
          return (
            <div key={step.number} className="stepper-item">
              <div className="stepper-circle-container">
                <div className={`stepper-circle ${
                  isCompleted ? 'completed' : 
                  isCurrent ? 'current' : 'pending'
                }`}>
                  {isCompleted ? (
                    <i className="bi bi-check"></i>
                  ) : (
                    step.number
                  )}
                </div>
                <div className="stepper-label">{step.label}</div>
              </div>
              
              {index < steps.length - 1 && (
                <div className={`stepper-line ${
                  step.number < currentStep ? 'completed' : 
                  step.number === currentStep ? 'current' : 'pending'
                }`}></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}